import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import TextField from '../../views/common/TextField';
import I18n from '../../../config/i18n';
import { getFinalValueForValidation } from '../../common/validations';

export default class Drive extends React.Component {
  constructor(props) {
    super(props);

    this.totalStockFieldRef = React.createRef();
    this.triggerChange = this.triggerChange.bind(this);
  }

  triggerChange(value) {
    const index = this.props.index;
    const validatedFinalValue = parseInt(getFinalValueForValidation(value));
    const totalStock =
      value.length > 0 && !_.isNaN(validatedFinalValue)
        ? validatedFinalValue
        : value;
    const newDrive = Object.assign({}, this.props.drive, { totalStock });

    this.props.onChange(newDrive, index);
  }

  getDriveTotalStock(totalStock) {
    return totalStock === 0 ? '' : totalStock;
  }

  render() {
    const { drive, driveType, errors } = this.props;
    return (
      <div className="clearfix">
        <div className="col col-3">
          <div className="h5 py2">{driveType && driveType}</div>
        </div>
        <div className="col col-2">
          <TextField
            autofocus
            ref={this.totalStockFieldRef}
            fullWidth
            type="tel"
            maxLength={3}
            errorText={
              errors && errors.totalStock && I18n.t('enterAValidValue')
            }
            hintText={I18n.t('quantity')}
            value={drive.totalStock}
            handleChange={this.triggerChange}
          />
        </div>
      </div>
    );
  }
}

Drive.propTypes = {
  index: PropTypes.number.isRequired,
  drive: PropTypes.object.isRequired,
  errors: PropTypes.any,
  onChange: PropTypes.func.isRequired,
};
